export default __webpack_public_path__ + "static/media/pharmacy.733053f0.png";